import React, { useState, useEffect } from 'react';
const { forwardRef, useRef, useImperativeHandle } = React;

const SpeakGender = forwardRef((props, ref) => {
  const [Voices, setVoices] = useState(null);

  useEffect(() => {
    const voiceschanged = () => {
      let voi = speechSynthesis.getVoices();
      setVoices(voi);
    };

    voiceschanged();
    if (speechSynthesis.onvoiceschanged !== undefined) {
      speechSynthesis.onvoiceschanged = voiceschanged;
    }
  }, []);


  useImperativeHandle(ref, () => ({
    SpeakText(text) {
      if (text != '') {
        var msg = new SpeechSynthesisUtterance();
        let DE_voice = Voices.filter((voice) => /de/.test(voice.lang))[0];
        msg.voice = DE_voice;
        msg.lang = DE_voice.lang;
        msg.rate = 3;
        msg.text = text;
        speechSynthesis.speak(msg);
      }
    },
  }));

  return <div></div>;
});

export default SpeakGender;
